import React from "react";
import { Slider, Stack, Typography } from "@mui/material";

export const Input_SwitchN = ({ avail = ["default", "off", "on"], colors = ["#d3d3d3", "#fc0000", "#008000"], name, value, onChange_nv }) => {

  return (
    <Stack direction="row" spacing={2} >
      <Slider
        sx={{
          minWidth: avail.length * 12, maxWidth: avail.length * 12,
          color: colors[avail.indexOf(value)]
        }}
        name={name}
        min={0}
        max={avail.length - 1}
        value={avail.indexOf(value)}
        onChange={(e) => onChange_nv(e.target.name, avail[e.target.value])}
        marks={true}
        size="small" // "medium"
        valueLabelDisplay="off"

      />
      <Typography variant="body2" gutterBottom={false}>
        {avail[value]}
      </Typography>

    </Stack>
  );
};

